<table mat-table multiTemplateDataRows [dataSource]="tableItems">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Outlet</th>
    <td mat-cell *matCellDef="let item">
      <span>
        @if (item.outlet) {
          <contact-link [subject]="item.outlet">
          </contact-link>
        } @else {
          {{ item.name }}
        }
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let item">
      <span>{{ item.type }}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="closingDate">
    <th mat-header-cell *matHeaderCellDef>Fund Closing Date</th>
    <td mat-cell *matCellDef="let item">
      <span>{{ item.closingDate }}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Fund Status</th>
    <td mat-cell *matCellDef="let item">
      <span>{{ item.status }}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let item" [attr.colspan]="headerColumns.length">
      <table mat-table [dataSource]="item.details">
        <ng-container matColumnDef="creditType">
          <th mat-header-cell *matHeaderCellDef="">Credit Type</th>
          <td mat-cell *matCellDef="let item">{{ item.creditType }}</td>
        </ng-container>
        <ng-container matColumnDef="placementStatus">
          <th mat-header-cell *matHeaderCellDef="">Placement Status</th>
          <td mat-cell *matCellDef="let item">{{ item.placementStatus }}</td>
        </ng-container>
        <ng-container matColumnDef="ownership">
          <th mat-header-cell *matHeaderCellDef="">Ownership %</th>
          <td mat-cell *matCellDef="let item">
            @if (item.ownership) {
              {{ item.ownership }}
            } @else {
              &mdash;
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="admittedDate">
          <th mat-header-cell *matHeaderCellDef="">Admitted Date</th>
          <td mat-cell *matCellDef="let item">
            @if (
              item.admittedDate) {
              {{ item.admittedDate }}
            } @else {
              &mdash;
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="exitDate">
          <th mat-header-cell *matHeaderCellDef="">Exit Date</th>
          <td mat-cell *matCellDef="let item">
            @if (item.exitDate) {
              {{ item.exitDate }}
            } @else {
              &mdash;
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="subHeaderColumns"></tr>
        <tr
          mat-row
          class="detail-row"
        *matRowDef="let row; columns: subHeaderColumns"></tr>
      </table>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
  <tr mat-row class="top-row" *matRowDef="let row; columns: headerColumns"></tr>
  <tr
    mat-row
    class="sub-row"
  *matRowDef="let details; columns: ['details']"></tr>
</table>
